<template>
  <div class="shopItem">
    <div class="wrapper">
      <div class="inform_block">
        <div class="title_block">{{item.name}}</div>
        <div class="box2">{{item.text}}</div>

<!--        <div class="map_block"><span @click="$emit('setMapAndFocus',item.id)" class="onMap">{{mess.tabOnMap}}</span></div>-->
      </div>
      <div class="img_block" :style="'background-image: url('+item.picture+');'"><a :href="item.link"></a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shops_list_item",
  props:["item","mess"],
}
</script>

<style scoped>
.tab.adress .shopItem {
  border-left: solid 1px #67696b;
  border-bottom: solid 1px #67696b;
  border-right: solid 1px #67696b;
  width: 50%;
  padding: 2%;
}
.tab.adress .shopItem:first-child,
.tab.adress .shopItem:nth-child(2) {
  border-top: solid 1px #67696b;
}
.tab.adress .shopItem:nth-child(2n) {
  border-left: 0;
}
.wrapper {
  display: flex;
  align-items: stretch
}
.wrapper>div {

  padding: 5px;
  width: 50%;
}
@media (max-width: 993px) {
  .tab.adress .shopItem {
    border: solid 1px #67696b;
    width: 100%;
    border-top: 0;
  }
  .tab.adress .shopItem:nth-child(2n) {
    border-left: solid 1px #67696b;
    border-top: 0;
  }
}
@media (max-width: 630px) {
  .shopItem .wrapper>div {
    width: 100%;
  }
  .wrapper {
    flex-wrap: wrap;
  }
}




.img_block {
  display: block;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 260px;
}
.inform_block {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.img_block a {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.onMap {
  cursor: pointer;
  color: #e4c2c0;
}
.onMap:before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMTcuMTUgMjQiPjxkZWZzPjxjbGlwUGF0aCBpZD0iMWM2ZjNiNGEtNGEwNS00MzZmLWE3NWMtZTVkYjA0YmE1NTY1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSI+PHJlY3Qgd2lkdGg9IjE3LjE1IiBoZWlnaHQ9IjI0IiBzdHlsZT0iZmlsbDpub25lIi8+PC9jbGlwUGF0aD48L2RlZnM+PHRpdGxlPmZpbmQtc2hvcDwvdGl0bGU+PGcgaWQ9ImIyNzU4NjY4LWRiZjQtNDRmOS04YjA3LTUwZTFlODhjZTJjZiIgZGF0YS1uYW1lPSLQodC70L7QuSAyIj48ZyBpZD0iOWU3MjViYWYtYjM3Ni00MDk3LThmYTgtMGJkYjM4MjY3ZWE3IiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIHN0eWxlPSJjbGlwLXBhdGg6dXJsKCMxYzZmM2I0YS00YTA1LTQzNmYtYTc1Yy1lNWRiMDRiYTU1NjUpIj48cGF0aCBkPSJNOC44OCwwQTguNTcsOC41NywwLDAsMCwwLDguNThjMCw1LjQ5LDUuMjcsOS40Nyw4LjIyLDE1LjJhLjQxLjQxLDAsMCwwLC43MiwwYzIuNjctNS4xNSw3LjI0LTguNjEsOC4wOC0xMy41OEE4LjY5LDguNjksMCwwLDAsOC44OCwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSIgc3R5bGU9ImZpbGw6I2U0YzJjMCIvPjxwYXRoIGQ9Ik04LjU4LDEwLjA2YTEuNDksMS40OSwwLDAsMCwzLDAsMS4xMiwxLjEyLDAsMCwwLS4wNS0uMzVoMGMuNzQtMS4xNC0uMTQtMS42NS0uODQtMi4xNmEzLjM3LDMuMzcsMCwwLDEtLjYtLjU3bC40NS0uODhhMS4yNiwxLjI2LDAsMCwwLC4yNywwLC44OS44OSwwLDEsMC0uNDYtMS42NSwyLjY5LDIuNjksMCwwLDAtMy41MSwwLC44OS44OSwwLDEsMC0uNDYsMS42NSwxLjA5LDEuMDksMCwwLDAsLjI2LDBMNy4wOCw3YTMuMzcsMy4zNywwLDAsMS0uNi41N2MtLjcuNTEtMS41OCwxLS44NCwyLjE2aDBhMS4xMiwxLjEyLDAsMCwwLDAsLjM1LDEuNDUsMS40NSwwLDAsMCwxLjQ5LDEuNDIsMS40NSwxLjQ1LDAsMCwwLDEuNDktMS40MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCkiIHN0eWxlPSJmaWxsOiNmZmYiLz48L2c+PC9nPjwvZz48L3N2Zz4=");
  vertical-align: middle;
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 10px;
}


</style>